import { Box, ButtonBase } from '@mui/material';

function TabNavigation({ activeTab, setActiveTab }) {
  const tabs = ["Live cam", "Timelapse cam", "AI cam"];

  return (
    <Box sx={{ display: 'flex', gap: '24px', mb: 1 }}>
      {tabs.map((tab) => (
        <ButtonBase
          key={tab}
          onClick={() => setActiveTab(tab)}
          disableRipple
          className={`cam-tab ${activeTab === tab ? 'tab-active' : ''}`}
          sx={{
            fontSize: '16px',
            fontWeight: 600,
            transition: 'all 0.3s',
            display: 'inline-block',
            pb: 1, // padding bottom
          }}
        >
          {tab}
        </ButtonBase>
      ))}
    </Box>
  );
}

export default TabNavigation;